import { ColumnMeta, RowData } from '@tanstack/react-table';
import { IScheduleFieldsFragment } from '../../../utils/apollo/graphqlSchema';

export const scheduleAnalysisColumnsConfig: Record<
  string,
  ColumnMeta<IScheduleFieldsFragment, RowData>
> = {
  name: {
    style: {
      minWidth: '180px',
      flex: 2,
      textAlign: 'left',
    },
  },
  description: {
    style: {
      minWidth: '200px',
      flex: 3,
      textAlign: 'left',
    },
  },
  recipients: {
    style: {
      minWidth: '100px',
      flex: 1,
      textAlign: 'left',
    },
  },
  alertState: {
    style: {
      minWidth: '80px',
      flex: 1,
      textAlign: 'left',
    },
  },
  recurrence: {
    style: {
      minWidth: '160px',
      flex: 1,
      textAlign: 'left',
    },
  },
  nextRun: {
    style: {
      minWidth: '160px',
      flex: 1,
      textAlign: 'left',
    },
  },
  lastRun: {
    style: {
      minWidth: '160px',
      flex: 1,
      textAlign: 'left',
    },
  },
  actions: {
    style: {
      minWidth: '50px',
      flexBasis: '50px',
    },
  },
};
